import { render, staticRenderFns } from "./UserListHeader.vue?vue&type=template&id=f870145a&scoped=true"
import script from "./UserListHeader.vue?vue&type=script&lang=ts"
export * from "./UserListHeader.vue?vue&type=script&lang=ts"
import style0 from "./UserListHeader.vue?vue&type=style&index=0&id=f870145a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f870145a",
  null
  
)

export default component.exports